// extracted by mini-css-extract-plugin
module.exports = {"tags":"tags-m__tags__wdWsW","roundCorners":"tags-m__roundCorners__2gq1W","dark":"tags-m__dark__J0FXz","light":"tags-m__light__2gPAF"};